import { StatusEnum, BroadCastTypes } from 'enums/enums'
import { NETWORK_TABLE_FLAG_COLUMNS } from './networkParticipation'

export const LABEL_DISPLAY = {
  REOPEN_INVOICE_LABEL: 'ReOpen Invoice',
  OPEN_LABEL: 'Open',
  CLOSED_LABEL: 'Close',
  AGED_INVOICE_LABEL: 'Aged Invoice',
  MONTHLY_VEHICLECOUNT_LABEL: 'Monthly RO Count',
  POTENTIAL_MONTHLY_RO_COUNT_LABEL: 'Potential Monthly RO Count',
  HELP_SECTION_LABEL: 'HELP SECTION',
  CALIBRATION_DIAGNOSTIC_LABEL: 'Calibration Diagnostic',
  CAR_ADAS_IT_LABEL: 'Car ADAS+ IT',
  SUPPORT_TYPE_LABEL: 'SUPPORT TYPE',
  REQUEST_TYPE_LABEL: 'REQUEST TYPE',
  WORK_ORDER_QUOTE_INVOICE_LABEL: 'Work Order/Quote/Invoice',
  INFORMATION_REQUEST_LABEL: 'Information Request',
  SCHEDULED_MAINTENANCE: 'Scheduled Maintenance',
  VERSION_NUMBER: 'v3.1.2',
  REBATE_OR_DISCOUNT_PERCENT_LABEL: 'Rebate/Discount Percent',
  REBATE_DISCOUNT_LABEL: 'Rebate/Discount'
}

export const BUTTONS_DISPLAY_LABEL = {
  CANCEL: 'CANCEL',
  REOPEN_INVOICE_LABEL: 'REOPEN INVOICE',
  CONFIRM: 'CONFIRM',
  SCORECARD: 'SCORECARD',
  DELETE: 'DELETE',
  YES: 'YES',
  NO: 'NO',
  NEW_WORK_ORDER: 'NEW WORK ORDER',
  NEW_QUOTE: 'NEW QUOTE',
  CREATE: 'CREATE',
  VIEW_RESULTS: 'View Results',
  // CAR-3677 — single label for the create-appointment action, shared by the
  // Quote Queue selection ribbon and the Scheduler "New Appointment" modal.
  NEW_APPOINTMENT: 'New Appointment'
}

export const GENERIC_MESSAGES = {
  REOPEN_CODE: 'OPEN',
  REOPEN_INVOICE_TITLE: 'Reopen Closed Invoice',
  CONFIRM_REOPEN_INVOICE: 'To confirm that you want to reopen this Invoice, type ‘OPEN’ below.',
  ADMIN_CODE_TITLE: 'System Admin Code Required',
  ADMIN_CODE_REQUIRED: 'A System Admin code is required to reopen a closed Invoice.',
  REVERT_TO_WO_TITLE: 'Move Invoice back to a Work Order',
  REVERT_TO_WO: 'Click the Confirm button to move Open Invoice back to a Work Order',
  OPENING_DATE_CHECK: 'Opening date must be in the past',
  CONFIRM_DELETE_PHOTO: 'Are you sure you want to delete this photo?',
  DELETE_PHOTO: 'Delete Photo',
  PHOTOS_UPLOADED: ' Photos Uploaded',
  PHOTO_UPLOADED: ' Photo Uploaded',
  SEARCH_ALL: 'Search for Quotes, Work Orders and Invoices',
  VIN_MUST_MATCH: 'VIN must be an exact match',
  NO_RECORDS_FOUND: 'No Records Found',
  TRY_OTHER_VIN: 'Try another VIN or Open a New Work Order or Quote',
  SEARCH_RESULTS: 'SEARCH RESULTS',
  TIRE_PRESSURE_CHECK: 'Ensure all tires have correct tire pressure',
  INVOICE_CLOSING_TIMELINE: 'Invoices should be closed within 2 days of the Invoice Create date',
  CONTACT_DELETED: 'Contact Deleted',
  SAFETY_SYSTEMS_UPDATED: 'Safety Systems Updated',
  PRIMARY_DIAGNOSTIC_TOOL: 'Primary Diagnostic Tool Used During Calibration',
  MAX_POTOS: 'Max Photos',
  INVOICES_CAN_REOPEN_ASSISTANCE_MESSAGE: 'Please contact support@caradas.com for further assistance.',
  UNABLE_TO_REOPEN_INVOICE_TITLE: 'Unable to Reopen Invoice',
  INVOICES_CAN_REOPEN_WITH_IN_MONTH: 'Invoices can only be reopened in the month they were closed.',
  INVOICE_EXTRACT: 'Select the date range for the invoice extract',
  EXPORT_INVOICE_CSV: 'Export Invoice CSV',
  CREATE_SUPPORT_REQUEST: 'Create Support Request',
  SUPPORT_REQUESTING_ASSITANCE:
    'Before requesting assistance, please review the link below for documentation that may expedite the resolution of your issue',
  CONFIRM_CANCEL_REQUEST: 'Are you sure you want to cancel the request?',
  CANCEL_REQUEST_TITLE: 'Cancel Request',
  CONFIRM_UPDATE: 'Confirm Update',
  SUPPORT_UPDATE_INFO: 'An email will be sent if Resolution was updated. Are you sure you want to update the request?',
  EXPORT_INVOICE_CSV_DATE_RANGE_WARNING: 'Selected date cannot exceed two calendar months. Please update.',
  START_BROADCAST_TITLE: 'Admin Code to Start Broadcast',
  BROADCAST_INFO_MESSAGE: 'The message will be sent to all the users. Please enter the system admin code to confirm.',
  SYSTEM_ADMIN_CODE: 'System Admin Code',
  ADD_CALIBRATIONS: 'Add Calibrations',
  CLICK_CONFIRM_SERVICE_ONLY_WO_TO_STANDARD_WO_MESSAGE:
    'Click Confirm to convert Service Only work order to a Standard work order. Action cannot be undone.',
  END_BROADCAST_TITLE: 'End Broadcast',
  END_BROADCAST_MESSAGE: 'Are you sure you want to end the broadcast to all the users? This cannot be undone.',
  INCORRECT_ADMIN_CODE: 'Incorrect Admin Code',
  DELETE_USER: 'Delete User from Calibration Center',
  DELETE_USER_MESSAGE: 'User will be removed from calibration center. Click confirm to delete user. Action cannot be reverted.',
  OPT_IN_LINE_ITEMS_TITLE: 'Admin Code to Update QuickBooks',
  OPT_IN_LINE_ITEMS_YES_MESSAGE: 'Calibration Center has approved product line item invoicing in QBO',
  OPT_IN_LINE_ITEMS_NO_MESSAGE: 'Standard sales line item invoicing enabled by default',
  OEM_STATEMENT_HELPER_MESSAGE:
    '* OEM Position Statements are updated frequently. Please contact support if files should be added or updated.',
  DATE_OVERRIDES_MESSAGE: 'Use this option to change your availability for specific dates, overriding the weekly schedule.',
  VIN_MATCH_FOUND_TITLE: 'VIN Match Found',
  VIN_MATCH_FOUND_MESSAGE:
    'We found existing records tied to this VIN. Click the View Results button to review all related records tied to this vehicle.',
  CLIENT_IMPORT_INSTRUCTIONS: ['Ensure all fields are populated ', 'Remove duplicate records', 'Save and upload file'],
  FILE_LIMIT_EXCEEDED: 'Maximum file size allowed: 10MB',
  FILE_NAME_SIZE_EXCEEDED: 'The file name cannot exceed more than 80 characters.'
}

export const DATE_FORMATS = {
  ISO_DATE_STRING: 'MM/DD/YYYY',
  ISO_TIME_STRING: 'hh:mm A',
  ISO_DATE_TIME_STRING: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  ISO_DATE_TIME_SHORT_STRING: 'MM/DD/YYYY hh:mm a',
  ISO_DATE: 'YYYY-MM-DD',
  UTC_DATE_TIME: 'YYYY-MM-DDTHH:MM:00Z'
}

export const PARAM_NAMES = {
  REFERENCE_NUMBER: 'reference_number',
  CLIENT_ID: 'client_id'
}

export const REDIRECT_URLS = {
  FORBIDDEN_PAGE: '/forbidden',
  INVOICE_SUMMARY: `/invoices/:${PARAM_NAMES.REFERENCE_NUMBER}/summary`,
  WORK_ORDER_SUMMARY: `/workorders/:${PARAM_NAMES.REFERENCE_NUMBER}/summary`,
  QUOTE_SUMMARY: `/quotes/:${PARAM_NAMES.REFERENCE_NUMBER}/summary`,
  QUOTE_DOCUMENT: `/quotes/:${PARAM_NAMES.REFERENCE_NUMBER}/document`,
  NEW_QUOTE: '/quote/new-quote',
  NEW_WORK_ORDER: '/workorder/new-work-order',
  WORK_ORDER_VEHICLE_INFO: `/workorders/:${PARAM_NAMES.REFERENCE_NUMBER}/vehicle-info`,
  WORK_ORDER_PHOTO: `/workorders/:${PARAM_NAMES.REFERENCE_NUMBER}/photos`,
  WORK_ORDER_POST_CALIBRATION: `/workorders/:${PARAM_NAMES.REFERENCE_NUMBER}/post-calibration`,
  WORK_ORDER_PRE_CALIBRATION: `/workorders/:${PARAM_NAMES.REFERENCE_NUMBER}/pre-calibration`,
  WORK_ORDER_DOCUMENT: `/workorders/:${PARAM_NAMES.REFERENCE_NUMBER}/document`,
  WORK_ORDER_CALIBRATION: `/workorders/:${PARAM_NAMES.REFERENCE_NUMBER}/calibration`,
  INVOICE_PHOTO: `/invoices/:${PARAM_NAMES.REFERENCE_NUMBER}/photo`,
  INVOICE_DOCUMENT: `/invoices/:${PARAM_NAMES.REFERENCE_NUMBER}/document`,
  QUOTE_VEHICLE_INFO: `/quotes/:${PARAM_NAMES.REFERENCE_NUMBER}/vehicle-info`,
  INVOICE_VEHICLE_INFO: `/invoices/:${PARAM_NAMES.REFERENCE_NUMBER}/vehicle-info`,
  INVOICE_POST_CALIBRATION: `/invoices/:${PARAM_NAMES.REFERENCE_NUMBER}/post-calibration`,
  INVOICE_PRE_CALIBRATION: `/invoices/:${PARAM_NAMES.REFERENCE_NUMBER}/pre-calibration`,
  INVOICE_CALIBRATION: `/invoices/:${PARAM_NAMES.REFERENCE_NUMBER}/calibration`,
  CLIENT_INVOICE_SUMMARY_PHOTO: `/invoice-summary/photo`,
  CLIENT_INVOICE_SUMMARY_DOCUMENT: `/invoice-summary/document`,
  CLIENT_INVOICE_SUMMARY: `/invoice-summary`,
  CREATE_SUPPORT_REQUEST: '/support/support-request',
  VIN_SEARCH: '/vinsearch',
  CLIENT_DETAILS: `/clients/:${PARAM_NAMES.CLIENT_ID}/details`,
  GLOBAL_CLIENTS: '/global-clients',
  NETWORK: '/network'
}

export const PHOTO_LABELS = {
  FRONT_CAMERA: 'FRONT CAMERA',
  ADD_PHOTO: 'ADD PHOTO',
  REAR_CAMERA: 'REAR CAMERA',
  SURROUND_VIEW_CAMERA: 'SURROUND VIEW CAMERA',
  BLIND_SPOT_MONITORING: 'BLIND SPOT MONITORING',
  FRONT_RADAR: 'FRONT RADAR',
  ADDITIONAL_PHOTOS: 'ADDITIONAL PHOTOS',
  CALIBRATION_SERVICE_PHOTOS: 'ADD CALIBRATION OR SERVICE PHOTO(S)',
  CALIBRATION_SERVICE_PHOTOS_1: 'ADDITIONAL CALIBRATION AND SERVICE PHOTOS'
}

export const FILE_UPLOAD = {
  TITLE: {
    UPLOAD_CALIBRATION_REPORT: 'UPLOAD CALIBRATION REPORT',
    UPLOAD_POST_TEST_DRIVE_SCAN_REPORT: 'UPLOAD POST TEST DRIVE SCAN REPORT',
    UPLOAD_COLLISION_REPAIR_ESTIMATE: 'UPLOAD COLLISION REPAIR ESTIMATE',
    UPLOAD_CALIBRATION_REQUIRED_REPORT: 'UPLOAD CALIBRATION REQUIRED REPORT',
    UPLOAD_PRE_CALIBRATION_SCAN_REPORT: 'UPLOAD PRE CALIBRATION SCAN REPORT',
    UPLOAD_WHEEL_ALIGNMENT_AUDIT: 'UPLOAD WHEEL ALIGNMENT AUDIT',
    UPLOAD_OEM_PROCEDURE: 'UPLOAD OEM PROCEDURE',
    UPLOAD_WHEEL_ALIGNMENT_REPORT: 'UPLOAD WHEEL ALIGNMENT REPORT',
    UPLOAD_PARTS_INVOICE: 'UPLOAD PARTS INVOICE'
  },
  LABEL: {
    CALIBRATION_REPORT: 'Calibration Report',
    POST_TEST_DRIVE_SCAN_REPORT: 'Post Test Drive Scan Report',
    COLLISION_REPAIR_ESTIMATE: 'Collision Repair Estimate',
    CALIBRATION_REQUIRED_REPORT: 'Calibration Required Report',
    PRE_CALIBRATION_SCAN_REPORT: 'Pre Calibration Scan Report',
    WHEEL_ALIGNMENT_AUDIT: 'Wheel Alignment Audit',
    OEM_PROCEDURE: 'OEM Procedure',
    WHEEL_ALIGNMENT_REPORT: 'Wheel Alignment Report',
    PARTS_INVOICE: 'Parts Invoice',
    ADDITIONAL_DOCUMENT: 'Additional Document'
  },
  TYPE_LABEL: {
    CALIBRATION_REPORT: 'calibrationReport',
    POST_TEST_DRIVE_SCAN_REPORT: 'postTestScanReport',
    COLLISION_REPAIR_ESTIMATE: 'collisionRepairEstimate',
    CALIBRATION_REQUIRED_REPORT: 'calRequiredReport',
    PRE_CALIBRATION_SCAN_REPORT: 'preCalReportScan',
    WHEEL_ALIGNMENT_AUDIT: 'wheelAlignmentAudit',
    OEM_PROCEDURE: 'oemProcedureScan',
    WHEEL_ALIGNMENT_REPORT: 'wheelAlignmentScan',
    PARTS_INVOICE: 'partsInvoice',
    ADDITIONAL_DOCUMENT: 'docWorkOrder',
    PRE_CALIBRATION_REPAIR_ESTIMATE_SCAN: 'preCalRepairEstimateScan'
  }
}

export const USER_TABLE_HEADERS = [
  { id: 'name', label: 'Name', minWidth: '150px' },
  { id: 'email', label: 'Email', minWidth: '100px' },
  { id: 'phone', label: 'Phone', minWidth: '100px' },
  { id: 'role', label: 'Role', minWidth: '100px' },
  { id: 'is_active', label: 'Status', width: '60px', align: 'center' }
]
// Columns rendered on the Manage Locations page (operational/account fields).
// Network-participation flags now live on the dedicated Network page so this
// table stays scannable.
export const MANAGE_LOCATIONS_HEADERS = [
  { id: 'name', label: 'CC Name', minWidth: '200px' },
  { id: 'id', label: 'CC #', minWidth: '100px' },
  { id: 'group_number', label: 'Group #', minWidth: '100px' },
  { id: 'group_name', label: 'Group Name', minWidth: '120px' },
  { id: 'owners', label: 'Owner', minWidth: '120px', align: 'left' },
  { id: 'opening_date', label: 'Open Date', minWidth: '100px', align: 'left' },
  { id: 'is_active', label: 'Status', minWidth: '100px', align: 'center' }
]

// Kept as an alias for any older imports that may still reference CC_TABLE_HEADERS.
// New code should use MANAGE_LOCATIONS_HEADERS.
export const CC_TABLE_HEADERS = MANAGE_LOCATIONS_HEADERS

// Columns rendered on the Network Participation matrix. The flag columns are
// derived from NETWORK_PARTICIPATION_ITEMS (the same list the edit modal uses) so
// every enrollable carrier — CSAA included — surfaces automatically and the table
// can never drift from the modal again. Farmers is excluded via `showInTable`.
export const NETWORK_TABLE_HEADERS = [
  { id: 'name', label: 'CC Name', sortable: true },
  { id: 'id', label: 'CC #', sortable: false },
  ...NETWORK_TABLE_FLAG_COLUMNS
]

export const GLOBAL_DIRECTORY_HEADER = [
  {
    id: 'ccid',
    label: 'CC #',
    minWidth: '100px',
    align: 'left'
  },
  {
    id: 'center',
    label: 'CC Name',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'name',
    label: 'User Name',
    minWidth: '200px',
    align: 'left',
    // Plain text — editing is triggered by the dedicated pencil column, not the name.
    renderer: 'default'
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: '220px',
    align: 'left'
  },
  {
    id: 'role',
    label: 'Role',
    minWidth: '100px',
    align: 'left'
  },
  {
    id: 'is_active',
    label: 'Status',
    minWidth: '100px',
    align: 'center'
  },
  {
    id: 'edit',
    label: '',
    minWidth: '60px',
    align: 'center',
    sortable: false,
    renderer: 'editAction'
  }
]

export const PRODUCT_LIST_HEADERS = [
  {
    id: 'name',
    label: 'Product Name',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'category',
    label: 'Category',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'price',
    label: 'Price',
    minWidth: '100px'
  },

  {
    id: 'is_active',
    label: 'Status',
    minWidth: '100px',
    align: 'center'
  }
]

export const SERVICE_LIST_HEADERS = [
  {
    id: 'name',
    label: 'Product Name',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'category',
    label: 'Category',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'price',
    label: 'Price',
    minWidth: '100px'
  },
  {
    id: 'is_active',
    label: 'Status',
    minWidth: '100px',
    align: 'center'
  }
]
export const PARTS_LIST_HEADERS = [
  {
    id: 'name',
    label: 'Product Name',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'category',
    label: 'Category',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'price',
    label: 'Price',
    minWidth: '100px'
  },

  {
    id: 'is_active',
    label: 'Status',
    minWidth: '100px',
    align: 'center'
  }
]
export const LABOUR_LIST_HEADERS = [
  {
    id: 'name',
    label: 'Product Name',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'category',
    label: 'Category',
    minWidth: '200px',
    align: 'left'
  },
  {
    id: 'price',
    label: 'Hourly Rate',
    minWidth: '100px'
  },

  {
    id: 'is_active',
    label: 'Status',
    minWidth: '100px',
    align: 'center'
  }
]

export const CLIENT_LIST_HEADERS = [
  { id: 'name', label: 'Client Name', align: 'left', minWidth: '350px', sortable: false },
  { id: 'ccc_client_id', label: 'CCC ID', align: 'left', minWidth: '120px', sortable: false },
  { id: 'rebate_percent', label: 'Rebate %', align: 'right', minWidth: '100px', sortable: false },
  { id: 'auto_apply_rebate', label: 'Auto-Apply Rebate', align: 'left', minWidth: '80px', sortable: false },
  {
    id: 'vehicle_count',
    label: LABEL_DISPLAY.MONTHLY_VEHICLECOUNT_LABEL,
    align: 'right',
    minWidth: '80px',
    sortable: false
  },
  { id: 'is_active', label: 'Status', align: 'center', minWidth: '100px', sortable: false }
]

export const CLIENT_CONTACT_LIST_HEADERS = [
  { id: 'name', label: 'Name', align: 'left', minWidth: '200px' },
  { id: 'jobTitle', label: 'Job Title', align: 'left', minWidth: '200px' },
  { id: 'phone', label: 'Phone', align: 'left', minWidth: '150px' },
  { id: 'email', label: 'Email', align: 'left', minWidth: '200px' }
]

export const SUPPORT_TICKETS_ADMIN_VIEW_HEADERS = (type) => {
  return [
    { id: 'created_at', label: 'DATE CREATED', align: 'left', minWidth: '30px' },
    ...(StatusEnum[type] === StatusEnum.CLOSED ? [{ id: 'closed_at', label: 'DATE CLOSED', align: 'left', minWidth: '30px' }] : []),
    ...(StatusEnum[type] === StatusEnum.OPEN ? [{ id: 'updated_at', label: 'DATE UPDATED', align: 'left', minWidth: '30px' }] : []),
    { id: 'supportTicketId', label: 'SUPPORT #', align: 'left', minWidth: '30px' },
    { id: 'assignedTo', label: 'ASSIGNED TO', align: 'left', minWidth: '30px' },
    { id: 'support_type', label: 'SUPPORT TYPE', align: 'left', minWidth: '40px' },
    { id: 'problem_area', label: 'PROBLEM AREA', align: 'left', minWidth: '80px' },
    {
      id: 'calibration_name',
      label: 'CC NAME',
      align: 'left',
      minWidth: '30px'
    },
    { id: 'supportTicketStatus', label: 'STATUS', align: 'left', minWidth: '20px' }
  ]
}

export const SUPPORT_TICKETS_CC_VIEW_HEADERS = [
  { id: 'created_at', label: 'DATE CREATED', align: 'left', minWidth: '30px' },
  { id: 'supportTicketId', label: 'SUPPORT #', align: 'left', minWidth: '30px' },
  { id: 'support_type', label: 'SUPPORT TYPE', align: 'left', minWidth: '40px' },
  { id: 'problem_area', label: 'PROBLEM AREA', align: 'left', minWidth: '80px' },
  {
    id: 'contact_name',
    label: 'CONTACT NAME',
    align: 'left',
    minWidth: '30px'
  },
  { id: 'supportTicketStatus', label: 'STATUS', align: 'left', minWidth: '20px' }
]

export const TABLE_HEADER_STYLE = {
  fontWeight: '600',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}

export const CLIENT_TYPE_ENUM = {
  CUSTOMERPAY: 'Customer Pay',
  FLEET: 'Fleet'
}

export const WORK_ORDER_TYPE = {
  STANDARD: 'Standard',
  SERVICE_ONLY: 'Service Only'
}

// Optional package tier selectable when creating a new calibration center.
// `value` is the payload sent to the backend; `name` is the label shown in the dropdown.
export const PACKAGE_TYPE_OPTIONS = [
  { value: 'AI_REPORT', name: 'AI Report' },
  { value: 'AI_COMPLETE', name: 'AI Complete' }
]

export const getQuoteSummaryUrl = (id) => {
  return REDIRECT_URLS.QUOTE_SUMMARY.replace(`:${PARAM_NAMES.REFERENCE_NUMBER}`, id)
}

export const getWorkOrderSummaryUrl = (id) => {
  return REDIRECT_URLS.WORK_ORDER_SUMMARY.replace(`:${PARAM_NAMES.REFERENCE_NUMBER}`, id)
}

export const getInvoiceSummaryUrl = (id) => {
  return REDIRECT_URLS.INVOICE_SUMMARY.replace(`:${PARAM_NAMES.REFERENCE_NUMBER}`, id)
}

export const getClientDetailsUrl = (id) => {
  return REDIRECT_URLS.CLIENT_DETAILS.replace(`:${PARAM_NAMES.CLIENT_ID}`, id)
}
export const getUrlByNameAndId = (urlPath = '', id) => {
  return urlPath.replace(`:${PARAM_NAMES.REFERENCE_NUMBER}`, id)
}

export const RadioGroup_Constants = [
  {
    value: BroadCastTypes.INFO,
    label: 'Information Update'
  },
  {
    value: BroadCastTypes.CRITICAL,
    label: 'Critical Update'
  }
]

// CAR-4020 — the Help page FAQ, in display order. `group` drives the section headings on /help.
export const DEFAULT_FAQS = [
  {
    group: 'Getting started',
    q: 'What device is ADAS Intelligence built for?',
    a: ['Any internet-connected device with a current web browser: computer, tablet or phone.']
  },
  {
    group: 'Getting started',
    q: 'How do I reset my password?',
    a: ['Select Forgot password? on the sign-in page, enter your email and select Send Reset Link. Follow the link in the email.']
  },
  {
    group: 'Getting started',
    q: 'How do I add a new user?',
    a: [
      'Managers and Owners: go to Settings › Team & roles and select Add. Enter their details and role, then select Add User. The new user receives a welcome email.'
    ]
  },
  {
    group: 'Getting started',
    q: 'Can a Technician or Manager work at more than one location?',
    a: [
      'Yes. A Manager or Owner opens Settings › Team & roles in the other location, selects Add, chooses Existing and enters the person’s email.',
      'The user switches locations with the switcher at the top of the menu.'
    ]
  },
  {
    group: 'Getting started',
    q: 'Why should client and contact details stay up to date?',
    a: [
      'Client names, addresses and emails appear on quotes, invoices and emails. Review each client monthly.',
      'If a body shop shares estimates through CCC, add its CCC ID on the client’s Client Info tab.'
    ]
  },
  {
    group: 'Plans & billing',
    q: 'Which subscriptions are available?',
    a: [
      'Four subscriptions, billed monthly per location. Each includes everything in the one before it.',
      'AI Brief — $99.00: AI Reports and VIN Search.',
      'AI Core — $1,200.00: adds Clients, Quotes, Products, Work Orders, Invoices and the Certificate of Calibration.',
      'AI Complete — $1,800.00: adds the ADAS Library, Scheduler and the client guest portal.',
      'AI Complete Assist — $2,200.00: adds Support, QA Support and ADAS Library certification (required).'
    ]
  },
  {
    group: 'Plans & billing',
    q: 'How do I upgrade or downgrade?',
    a: [
      'Go to Settings › Billing. To upgrade, select Upgrade to [plan name]. The change applies right away.',
      'To downgrade, select Request downgrade. Our team makes the change at the end of your billing period.'
    ]
  },
  {
    group: 'Plans & billing',
    q: 'Why can’t I see Scheduler or the ADAS Library?',
    a: [
      'They are included in AI Complete and AI Complete Assist. To upgrade, go to Settings › Billing.',
      'After you upgrade, the ADAS Intelligence team turns Scheduler on for your location. If it hasn’t appeared, email support@adasintelligence.ai.'
    ]
  },
  {
    group: 'CCC & QuickBooks',
    q: 'How do I connect CCC so estimates arrive automatically?',
    a: [
      'Two parts, done once per shop:',
      '1. In CCC ONE: Configure › CCC Secure Share › Marketplace. Open the ADAS Intelligence tile and switch it to Enabled.',
      '2. In ADAS Intelligence: Settings › CCC connection. Type your shop’s CCC ID and select Save.',
      'Estimates you share from CCC ONE now arrive as AI Reports.'
    ]
  },
  {
    group: 'CCC & QuickBooks',
    q: 'Estimates from CCC aren’t arriving. What should I check?',
    a: [
      'Check that Settings › CCC connection shows your shop’s CCC ID, and that the ADAS Intelligence tile is Enabled in CCC ONE’s Secure Share Marketplace.'
    ]
  },
  {
    group: 'CCC & QuickBooks',
    q: 'How do I connect QuickBooks Online?',
    a: [
      'Managers and Owners: go to Settings › QuickBooks Online, select Connect and sign in to QuickBooks.',
      'If you don’t have QuickBooks Online yet, create the account with Intuit first.'
    ]
  },
  {
    group: 'CCC & QuickBooks',
    q: 'How do invoices get to QuickBooks?',
    a: ['On the Invoices list, select the invoices and choose Send to QBO. Sending also closes them in ADAS Intelligence.']
  },
  {
    group: 'CCC & QuickBooks',
    q: 'How do I fix a QuickBooks duplicate name error?',
    a: [
      'The name already exists in your QuickBooks account. Check Customers, Vendors, Employees and Products and Services in QuickBooks for the duplicate.',
      'If you can’t find it, contact Intuit QuickBooks support.'
    ]
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'What do I enter if I don’t have the RO number yet?',
    a: ['Enter TBD. You can update the RO number any time on the Vehicle Info page of the quote or work order.']
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'What is the difference between a Standard and a Service Only work order?',
    a: [
      'Standard includes calibrations and services, with full documentation and checklists.',
      'Service Only is a quicker, lighter form for services. It has no calibrations or checklists.'
    ]
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'Can Service Only be converted to a Standard work order?',
    a: [
      'Yes. On the Service Only work order, select Add Calibrations, then Confirm. This converts it to a Standard work order. It can’t be undone, and must be done before the work order is added to an invoice.',
      'A Service Only quote becomes a work order first: select Create Work Order, then Add Calibrations.'
    ]
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'Which photos and documents are required on a work order?',
    a: [
      'Photos are required. Document uploads are optional.',
      'Pre Calibration Set Up: the dash photo, four corner photos and four wheel photos, plus the odometer reading, fuel level and checklist.',
      'Post Calibration Checklist: the dash photo after calibration, plus the odometer reading and checklist.',
      'Scan reports, the repair estimate, wheel alignment and OEM procedure documents can be attached but aren’t required.'
    ]
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'I changed a product price. Why hasn’t my open work order changed?',
    a: [
      'New prices apply to new quotes and work orders only, so open records keep their pricing.',
      'To reflect the change on an open work order, add a Custom Charge.'
    ]
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'Are Custom Charges and Discounts added to my product catalog?',
    a: ['No. They are one-time items on that record only.']
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'Can I rename a product or change its price?',
    a: [
      'Owners can change a product’s name, price and description in Products. Managers can change the price only.',
      'A calibration product’s category can’t be changed. For one-off prices, use a Custom Charge on the record.'
    ]
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'Can I change a work order after it becomes an invoice?',
    a: [
      'While the invoice is open, a Manager or Owner can select Actions › Edit Invoice to move it back to a work order. Technicians can’t.',
      'A closed invoice can be reopened with Reopen Invoice: Owners at any time, Managers only in the month it was closed.',
      'If it was sent to QuickBooks, Send to QBO again after your changes and the QuickBooks invoice is updated.'
    ]
  },
  {
    group: 'Quotes, work orders & invoices',
    q: 'Where is the Certificate of Calibration?',
    a: ['Open the invoice and select Actions › View Certificate.']
  },
  {
    group: 'AI Reports',
    q: 'What is an AI Report?',
    a: [
      'An AI Report reads a collision estimate and lists the OEM-referenced calibration and safety findings for that vehicle. Review the findings, then select Download PDF or Create Quote.'
    ]
  },
  {
    group: 'AI Reports',
    q: 'How do estimates get into AI Reports?',
    a: ['Select Upload Estimate on the AI Reports page. Once CCC is connected, estimates shared from CCC ONE arrive automatically.']
  },
  {
    group: 'AI Reports',
    q: 'Where do I find report PDFs?',
    a: [
      'AI Report: open the report and select Download PDF.',
      'Scan and calibration reports from a job: open the work order and select Documents.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'How do I set up Scheduler?',
    a: [
      'The first time, an Owner opens Scheduler and selects SETUP.',
      'After that, Managers and Owners manage it in Scheduler › Calendar Settings:',
      '1. Hours: the days and times you take appointments.',
      '2. Preferences: appointment length, how many can run at once, booking notice and who gets emails.',
      '3. Overrides: holidays and other closed dates.',
      '4. Select Save Changes.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'How do I change appointment length or start times?',
    a: [
      'Calendar Settings › Preferences. Duration of Appointment sets the time reserved for each booking.',
      'Start Every sets how often a slot opens: at 90 minutes, slots start at 8:00, 9:30, 11:00 and so on.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'Can more than one appointment be booked at the same time?',
    a: ['Yes. Calendar Settings › Preferences › Technicians sets how many appointments can run at once.']
  },
  {
    group: 'Scheduler',
    q: 'How do I stop last-minute or far-off bookings?',
    a: [
      'Calendar Settings › Preferences. Minimum Time Before Booking sets the shortest notice. Maximum Days in Advance sets how far ahead customers can book.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'What are Date Overrides?',
    a: [
      'They change your availability for a specific date without changing your weekly hours.',
      'Mark a holiday unavailable all day, or set partial hours: Calendar Settings › Overrides › Add Date.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'How do customers book online?',
    a: [
      'Calendar Settings › View Booking Link gives you a direct link, a QR code to copy or download, and embed code for your website.',
      'If your website or an old QR code still uses a previous booking page, replace it with these.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'Can appointment emails go to more than one person?',
    a: [
      'Yes. Calendar Settings › Preferences › Notification Recipients. Type each address and press Enter or a comma, then select Save Changes.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'Why can’t an appointment be booked at a certain time?',
    a: [
      'Every technician is already booked for that slot, it is outside your hours, or a date override blocks it.',
      'Review Hours, Overrides and Preferences in Calendar Settings.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'Can I book an appointment from a quote?',
    a: ['Yes. Open the quote and select Actions › New Appointment. The form fills in from the quote.']
  },
  {
    group: 'Scheduler',
    q: 'Can an appointment become a quote or work order?',
    a: [
      'Yes. Open the appointment and select Create Quote or Create Work Order. If the appointment came from a quote, you’ll see View Quote and Create Work Order instead.'
    ]
  },
  {
    group: 'Scheduler',
    q: 'Why are appointment times off by an hour?',
    a: ['Your location’s time zone is probably wrong. Check it in Settings › Account.']
  },
  {
    group: 'Troubleshooting',
    q: 'A page looks out of date or won’t load. How do I clear my browser cache?',
    a: [
      'Chrome: three-dot menu › Delete browsing data. Choose All time, check Cookies and other site data and Cached images and files, then delete and restart Chrome.',
      'Safari: Safari › Settings › Privacy › Manage Website Data › Remove All.'
    ]
  }
]

// Ordered least to most privileged; checkPermission compares positions. Client sits
// below tech: it is read-only, so anyone who can manage a tech can manage a client.
export const ROLES_HIERARCHY = ['client', 'tech', 'manager', 'owner', 'admin']

export const LIMITS = {
  QBO_CLASS_NAME_SIZE: 15,
  VIN_SEARCH_LIMIT_FROM_CREATION: 30
}

export const CALENDAR_PREFERENCES_MESSAGES = {
  TECHNICIANS:
    'Number of available technicians. Appointments will be scheduled based on the technician value selected in drop-down list, allowing for multiple appointments to be scheduled at the same time.',
  STARTTIMEINTERVALS:
    'Set Booking Intervals. Defines how often appointment slots are available for external scheduling. For example, with a 90-minute interval, appointments can be booked at 8:00 AM, 9:30 AM, 11:00 AM, etc., ensuring consistent spacing between appointments.',
  DURATION: 'Appointment Duration. Specifies the length of time reserved for each appointment.',
  GAP: 'Gap between each appointment',
  MINIMUMTIME: 'Minimum Advance Scheduling Time. Specifies the minimum amount of time required before an appointment can be scheduled',
  MAXIMUMDAYS: 'Maximum days in advance an appointment can be booked',
  MINHOURS: 'Minimum time allowed before an appointment can be rescheduled or canceled by external client online'
}

export const ERROR_MESSAGES = {
  TECHNICIANS: 'Invalid number of Technicians',
  DURATION: 'Appointment Duration is invalid',
  GAP: 'Gap Between Appointment is invalid',
  MINIMUMTIME: 'Minimum Time Before a Schedule that Client can book is invalid',
  MAXIMUMDAYS: 'Maximum Days Scheduled in Advance is invalid',
  MINHOURS: 'Minimum time required before the appointment to be rescheduled or canceled by an external client online is invalid'
}

export const TEXT_CONSTANTS = {
  INVALID_NAME: 'Invalid name. Only letters, numbers and spaces allowed.',
  INVALID_PHONE: 'Phone number is not valid.',
  INVALID_EMAIL: 'Email is not valid.',
  ENTER_VALID_EMAIL: 'Enter a valid email address.',
  INAVLID_ALPHANUMERIC: 'Value should be alpha-numeric.',
  INVALID_ALPHABETIC_TEXT: 'Only letters are allowed.',
  INVALID_ZIP: 'Invalid ZIP Code'
}

export const MAX_NOTES_LENGTH = 200
export const MAX_CLIENT_NOTES_LENGTH = 300

export const SCHEDULER_AUTO_REFRESH_MINUTES = 15

export const MAX_FILE_SIZE_MB = 10

export const CLIENT_LIST_UPLOAD_LIMIT = 2097152

export const FILE_NAME_LIMIT_IN_CHARS = 80
export const MAX_DESCRIPTION_LENGTH = 256

// Which invoice PDF the backend should render (`variant` query param on
// GET /v1/invoices/{id}/pdf). RETAIL is the plain document: it shows the custom discounts
// but leaves the client rebate off, totals to the pre-rebate figure, and carries no
// watermark (CAR-3893). COST adds the client rebate and its lower total — watermarked
// "Cost Invoice" so the two are never confused on paper.
export const INVOICE_PDF_VARIANT = {
  RETAIL: 'retail',
  COST: 'cost'
}

// Which invoice document(s) an Email Invoice send carries. The picker shown ahead of the
// email form resolves to one of these; `invoiceVariantsForEmailChoice` expands it into the
// list of INVOICE_PDF_VARIANT values to attach and to hand the backend.
export const INVOICE_EMAIL_VARIANT_CHOICE = {
  RETAIL: 'retail',
  COST: 'cost',
  BOTH: 'both'
}

export const invoiceVariantsForEmailChoice = (choice) => {
  if (choice === INVOICE_EMAIL_VARIANT_CHOICE.BOTH) return [INVOICE_PDF_VARIANT.RETAIL, INVOICE_PDF_VARIANT.COST]
  if (choice === INVOICE_EMAIL_VARIANT_CHOICE.COST) return [INVOICE_PDF_VARIANT.COST]
  return [INVOICE_PDF_VARIANT.RETAIL]
}
